import React, { memo, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { formatTimeDate } from '@/utils/functions/formatTimeDate';
import { CheckPermission } from '@/utils/permissions/permissions';

import LettersItemMenu from '@/views/pages/Letters/elements/LettersItemMenu';

const LettersItem = ({
	data,
	onEditItem,
	onDeleteItem,
	onCreateTemplate,
}) => {
	const { dict } = useSelector((state) => state.app);
	const { titleTypes, recipientsDict, categoriesDict } = useSelector(state => state.data);
	const user = useSelector((state) => state.auth.user);

	const userRole = user && user.role;

	const [ titleType, setTitleType ] = useState(null);

	const [ showCreateTemplateButton, setShowCreateTemplateButton ] = useState(false);

	useEffect(() => {
		if (titleTypes && data.titleType) {
			setTitleType(dict.titletypes[data.titleType]);
		}
	}, [ titleTypes, data, dict.titletypes ]);

	useEffect(() => {
		setShowCreateTemplateButton(onCreateTemplate && data.id && data.rights.canCreateLetterTemplate);
	}, [ onCreateTemplate, data ]);

	const letterTemplate = (templateId, canCreateTemplate) => {
		if (templateId) {
			return (
				<Link
					className='table__item--btn title-blue col-inline'
					to={ `/template/${templateId}` }
					style={ { fontWeight: "400" } }
				>
					{dict.letter.template.useTemplateButton}
				</Link>
			);
		} else if (!CheckPermission('canCreateTemplate', userRole)) {
			return dict.letter.template.none;
		}

		return (
			<div
				className={ `table__item--btn col-inline title-blue${canCreateTemplate ? '' : ' disabled' }` }
				onClick={ () => { onCreateTemplate(data.id); } }
				disabled={ canCreateTemplate }
				style={ { fontWeight: 400 } }
			>
				+ {dict.letter.template.createTemplate}
			</div>
		);
	};

	return (
		<div className='table__item'>
			<div className='table__item--col col-mobile-column'>
				<div className='table__item--col-label'>{dict.letters.table.title}: </div>
				<Link
					className='table__item--btn title-blue'
					to={ `/letter/${data.id}` }
				>{data.title}
				</Link>
				{titleType && (<div className='table__item--version col-inline'>{titleType}</div>)}
			</div>

			<div className='table__item--col'>
				<div className='table__item--col-label'>{dict.letters.dept}: </div>
				{data.department.name}
			</div>
			<div className='table__item--col'>
				<div className='table__item--col-label'>{dict.letters.table.editDate}: </div>
				{formatTimeDate(data.modifiedOn)}
			</div>
			<div className='table__item--col'>
				<div className='table__item--col-label'>{dict.letters.recipient}: </div>
				{recipientsDict[data.recipient.code]}
			</div>
			<div className='table__item--col col-mobile-column'>
				<div className='table__item--col-label'>{dict.letters.initiator}: </div>
				<div className='col-inline'>{data.owner.forename} {data.owner.surname} <div className='table__item--email col-inline'>{data.owner.email}</div></div>
				
			</div>
			<div className='table__item--col'>
				<div className='table__item--col-label'>{dict.letters.table.version}: </div>
				{dict.versions[data.version.replaceAll('-', '')]} {data.changes && <span>({data.changes})</span>}
			</div>
			<div className='table__item--col'>
				<div className='table__item--col-label'>{dict.letter.categories.category}: </div>
				{categoriesDict[data.category.code]}
			</div>

			<div className='table__item--col'>
				<div className='table__item--col-label'>{dict.letter.template.template}: </div>
				{ letterTemplate(data.letterTemplateId, showCreateTemplateButton) }
			</div>
			{(data.rights.canDelete || data.rights.canEdit) && <div 
				className="table__item--col col-flex" 
				style={ { overflow: "unset", marginTop: '2px' } }
			>
				<LettersItemMenu
					onEditItem={ onEditItem }
					onDeleteItem={ onDeleteItem }
					data={ data }
					disabled={ true }
					hasTemplate={ !!data.letterTemplateId }
				/>
			</div>}
		</div>
	);
};

export default memo(LettersItem);